<h2 mat-dialog-title>{{ 'tracingReports.dialog.columns.title' | translate }}</h2>
<p>{{ 'tracingReports.dialog.columns.subtitle' | translate }}</p>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="space-between start">
    <mat-list>
      <mat-list-item *ngFor="let item of checkbox_list">
        <mat-checkbox
          [checked]="item.checked"
          (change)="item.checked = !item.checked"
          [disabled]="(!item.checked && maxColumns === 7) || item.name === 'request'"
          [labelPosition]="item.labelPosition"
          (change)="list_change(item)"
          >{{ item.text }}</mat-checkbox
        >
      </mat-list-item>
    </mat-list>
  </div>
</mat-dialog-content>
<mat-divider class="dialog__divider--bottom"></mat-divider>
<mat-dialog-actions align="end">
  <button
    id="cancelButtonDialog"
    mat-stroked-button
    color="accent"
    name="buttonCancel"
    (click)="cancel()"
    [mat-dialog-close]="true"
  >
    <span>{{ 'tracingReports.dialog.columns.cancel' | translate | uppercase }}</span>
  </button>
  <button
    id="selectButtonDialog"
    mat-flat-button
    color="accent"
    name="buttonSelect"
    (click)="selectColumns()"
    [mat-dialog-close]="true"
    [disabled]="maxColumns !== 7"
  >
    <span>{{ 'tracingReports.dialog.columns.continue' | translate | uppercase }}</span>
  </button>
</mat-dialog-actions>
